import { TargetingOption } from "./reducer";
import { CampaignDetails } from "../default/reducer";
import { RequestStatus } from "../../../request";

export const FetchGenderOptions = () => {
  return {
    type: "campaign-details-fetch-gender-options",
  };
};

export const FetchOSOptions = () => {
  return {
    type: "campaign-details-fetch-os-options",
  };
};

export const FetchCountryOptions = () => {
  return {
    type: "campaign-details-fetch-country-options",
  };
};

export const ValidateAppAction = (playStoreUrl: string) => {
  return {
    type: "campaign-details-validate-app",
    playStoreUrl: playStoreUrl,
  };
};

export const PersistCampaignDetailsAction = (campaign: CampaignDetails) => {
  return {
    type: "campaign-details-persist",
    campaign: campaign,
  };
};

export const UpdateGenderOptionsAction = (options: TargetingOption[]) => {
  return {
    type: "campaign-details-update-gender-options",
    options: options,
  };
};

export const UpdateOSOptionsAction = (options: TargetingOption[]) => {
  return {
    type: "campaign-details-update-os-options",
    options: options,
  };
};

export const UpdateCountryOptionsAction = (options: TargetingOption[]) => {
  return {
    type: "campaign-details-update-country-options",
    options: options,
  };
};

export const UpdateFetchedIconUrlAction = (iconUrl: string) => {
  return {
    type: "campaign-details-update-fetched-app-icon-url",
    iconUrl: iconUrl,
  };
};

export const UpdatePersistCampaignRequestStateAction = (
  requestState: RequestStatus
) => {
  return {
    type: "campaign-details-update-campaign-request-state",
    requestState: requestState,
  };
};

export const FetchCampaignDetails = (campaignId: string) => {
  return {
    type: "campaign-details-fetch-campaign",
    campaignId: campaignId,
  };
};

export const UpdateCampaignDetailsAction = (campaign: CampaignDetails) => {
  return {
    type: "campaign-details-update-campaign",
    campaign: campaign,
  };
};

export const UpdateFetchCampaignRequestStateAction = (
  requestState: RequestStatus
) => {
  return {
    type: "campaign-details-update-fetch-campaign-request-state",
    requestState: requestState,
  };
};
